import React from "react";
import { useStatusBar } from "../context/StatusBarContext";

const StatusBar = ({ toolLabel, toolIcon: Icon }) => {
  const { info } = useStatusBar();

  return (
    <footer className="flex h-[22px] shrink-0 items-center justify-between bg-vscode-statusbar px-2 text-xs text-white select-none">
      <div className="flex items-center gap-3">
        {Icon && (
          <span className="flex items-center gap-1">
            <Icon size={13} strokeWidth={1.75} />
            {toolLabel}
          </span>
        )}
      </div>
      <div className="flex items-center gap-3">
        {info?.language && <span>{info.language}</span>}
        {info?.status && <span>{info.status}</span>}
        <span>UTF-8</span>
        <span>Dark+ (VS Code inspired)</span>
      </div>
    </footer>
  );
};

export default StatusBar;
